import { Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import LegalPageLayout, {
  ContactLine,
  LegalSection,
  SupportEmailLink,
  useLegalIdentity,
} from './LegalPageLayout';

export default function SmsTerms() {
  const { party } = useLegalIdentity();

  return (
    <LegalPageLayout
      title="SMS Terms of Service"
      crossLink={{ to: '/sms-privacy', label: 'SMS Privacy Policy' }}
    >
      <LegalSection title="1. Program description">
        {`${party} operates an administrative SMS messaging program (the
        "Program") used to deliver operational notifications and to accept
        administrative commands from authorized company personnel. Messages
        include, for example, system notifications, confirmations of
        administrative actions, and responses to commands initiated by the
        recipient.`}
      </LegalSection>

      <LegalSection title="2. Enrollment and consent">
        The Program is limited to Tenspace personnel and authorized users. Participants are enrolled
        at their own request by a Tenspace administrator, and consent to receive messages is given
        at the time of enrollment. Enrollment is not a condition of purchasing any goods or
        services. Consent may be revoked at any time as described below.
      </LegalSection>

      <LegalSection title="3. Message frequency and cost">
        Message frequency varies based on system activity and on commands the participant initiates.
        Message and data rates may apply according to the participant&apos;s mobile service plan.
        Tenspace does not charge for the messages themselves.
      </LegalSection>

      <LegalSection title="4. Opting out">
        Reply <strong>STOP</strong> to any message to opt out. After opting out you will receive a
        single message confirming your removal, and no further messages will be sent to your number.
        To re-enroll, contact a Tenspace administrator or reply <strong>UNSTOP</strong>.
      </LegalSection>

      <LegalSection title="5. Help">
        <Typography variant="body1" color="text.secondary">
          Reply <strong>HELP</strong> to any message for assistance, or contact <SupportEmailLink />
          .
        </Typography>
      </LegalSection>

      <LegalSection title="6. Supported carriers and liability">
        Messages are supported on major U.S. carriers. Carriers are not liable for delayed or
        undelivered messages. Delivery is subject to effective transmission by your network operator
        and is outside our control.
      </LegalSection>

      <LegalSection title="7. Privacy">
        <Typography variant="body1" color="text.secondary">
          Information collected through the Program is handled as described in our{' '}
          <Link component={RouterLink} to="/sms-privacy">
            SMS Privacy Policy
          </Link>
          . No mobile information or opt-in data is shared with third parties or affiliates for
          marketing or promotional purposes.
        </Typography>
      </LegalSection>

      <LegalSection title="8. Changes to these terms">
        We may update these terms from time to time. The effective date above reflects the most
        recent revision. Continued participation in the Program after a revision constitutes
        acceptance of the revised terms.
      </LegalSection>

      <LegalSection title="9. Contact">
        <ContactLine />
      </LegalSection>
    </LegalPageLayout>
  );
}
